import { Routes } from '@angular/router';
import { AuthGuard } from '../modules/auth/_services/auth.guard';

// This file contains only the route configuration to avoid circular dependencies
export const layoutRoutes: Routes = [
  {
    path: '',
    canActivate: [AuthGuard],
    loadChildren: () => import('./pages-routing.module').then(m => m.PagesRoutingModule),
  }
];
